import React from "react";
import RaikoDefaultDialogPage, {DialogSize} from "../../component/defaultDialogPage/RaikoDefaultDialogPage";
import ConfirmDialog from "../../component/deleteConfirmDialog/ConfirmDialog";
import PropTypes from "prop-types";


const RaikoConfirmDialog = (
    {
        cancelAction,
        openConfirmDialog,
        doAction,
        pageTitle = "حذف مورد",
        warningTitle = " آیا از حذف این آیتم اطمینان دارید ؟!",
        warningDescription = "با اتمام حذف امکان بازیابی آن وجود نخواهد داشت !!!",
        confirmButtonTitle,
        cancelButtonTitle
    }) => {


    return (
        <RaikoDefaultDialogPage
            onClose={cancelAction}
            open={openConfirmDialog}
            dialogSize={DialogSize.WRAP_CONTENT}
            pageTitle={pageTitle}
        >
            <ConfirmDialog
                cancelAction={cancelAction}
                doAction={doAction}
                title={warningTitle}
                description={warningDescription}
                confirmButtonTitle={confirmButtonTitle}
                cancelButtonTitle={cancelButtonTitle}
            />
        </RaikoDefaultDialogPage>
    )
}

RaikoConfirmDialog.propTypes = {
    cancelAction: PropTypes.func.isRequired,
    openConfirmDialog: PropTypes.bool.isRequired,
    doAction: PropTypes.func.isRequired,
}


export default RaikoConfirmDialog